import { MatDialogConfig } from '@angular/material/dialog';
import { GusDialogConfig } from '@shared/modules/dialog/models/dialog.models';
import { Subscription } from '@core/models/entities/subscription.model';
import { User } from '@core/models/entities/user.models';

/** Served from `public/images/` (see `angular.json` assets). */
export const PARTNER_SUBSCRIPTION_OFFER_DEFAULT_HERO_IMAGE = '/images/paywall-bg.png';

/** MatDialog options for `PartnerSubscriptionOfferDialogComponent`. */
export const PARTNER_SUBSCRIPTION_OFFER_DIALOG_PANEL_CONFIG: Pick<
  MatDialogConfig,
  'width' | 'maxWidth' | 'panelClass'
> = {
  panelClass: 'gus-partner-subscription-offer-dialog',
  width: '543px',
  maxWidth: 'calc(100vw - 32px)',
};

export type PartnerSubscriptionOfferDialogData = {
  user: User;
  subscriptionFromAccessCheck?: Subscription;
};

export const PARTNER_SUBSCRIPTION_OFFER_DIALOG_CONFIG: GusDialogConfig<PartnerSubscriptionOfferDialogData> = {
  hasPrimaryButton: false,
  hasSecondaryButton: false,
  hasCloseButton: false,
};
